import { Icon } from '~/components';
import { clsx } from '~/styles/utils';

import type { DiscountStep } from './DiscountProgress';

import {
  activeIndicatorStyle,
  activeItemStyle,
  contentStyle,
  hintStyle,
  indicatorStyle,
  itemStyle,
  labelStyle,
  lastActiveItemStyle,
} from './DiscountProgress.css';

type ItemProps = {
  isLastActiveItem?: boolean;
  item: DiscountStep;
};

export const DiscountProgressItem = ({ isLastActiveItem = false, item }: ItemProps) => {
  return (
    <li
      aria-current={isLastActiveItem ? 'step' : undefined}
      className={clsx(itemStyle, isLastActiveItem && lastActiveItemStyle, item.isActive && activeItemStyle)}
    >
      <div aria-hidden="true" className={clsx(indicatorStyle, item.isActive && activeIndicatorStyle)}>
        {item.isActive && <Icon name="Check" />}
      </div>

      <div className={contentStyle}>
        <span className={labelStyle}>{item.label}</span>

        {item.hint && <span className={hintStyle}>{item.hint}</span>}
      </div>
    </li>
  );
};
